export const MountAsWidget = () => (
  <div className='space-y-4'>
    <div className='rounded-lg bg-white p-6 shadow-sm'>
      <h2 className='mb-4 text-xl font-medium'>Widget Mode Content</h2>
      <div className='space-y-4'>
        <div className='flex items-center gap-4'>
          <div className='bg-slate-100 h-12 w-12 rounded-md' />
          <div className='flex-1'>
            <div className='bg-slate-100 h-4 w-1/3 rounded' />
            <div className='bg-slate-100 mt-2 h-3 w-1/2 rounded' />
          </div>
        </div>
        <div className='grid grid-cols-2 gap-4 sm:grid-cols-3'>
          <div className='bg-slate-100 rounded-md p-4'>
            <div className='bg-slate-200 h-3 w-2/3 rounded' />
            <div className='bg-slate-200 mt-2 h-6 w-1/2 rounded' />
          </div>
          <div className='bg-slate-100 rounded-md p-4'>
            <div className='bg-slate-200 h-3 w-2/3 rounded' />
            <div className='bg-slate-200 mt-2 h-6 w-1/2 rounded' />
          </div>
          <div className='bg-slate-100 rounded-md p-4'>
            <div className='bg-slate-200 h-3 w-2/3 rounded' />
            <div className='bg-slate-200 mt-2 h-6 w-1/2 rounded' />
          </div>
        </div>
      </div>
    </div>
  </div>
);
